import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";

export default function AdminLayout() {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Check if device is mobile
  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < 1024; // lg breakpoint
      setIsMobile(mobile);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Listen for sidebar state changes (desktop only)
  useEffect(() => {
    if (!isMobile) {
      const handleSidebarToggle = () => {
        const sidebar = document.querySelector('aside');
        if (sidebar) {
          const isCollapsed = sidebar.classList.contains('w-16');
          setIsSidebarCollapsed(isCollapsed);
        }
      };

      // Check initial state
      const timer = setTimeout(handleSidebarToggle, 100);

      // Listen for changes
      const observer = new MutationObserver(handleSidebarToggle);
      const sidebar = document.querySelector('aside');
      if (sidebar) {
        observer.observe(sidebar, { attributes: true, attributeFilter: ['class'] });
      }

      return () => {
        clearTimeout(timer);
        observer.disconnect();
      };
    }
  }, [isMobile]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-[#fff7f6] to-[#f9fafb]">
      <Sidebar />

      <main
        className={`transition-all duration-300 ease-in-out ${
          isMobile
            ? 'ml-0' // No margin on mobile
            : isSidebarCollapsed
              ? 'ml-16'
              : 'ml-64'
        }`}
      >
        <div className={`p-4 sm:p-6 ${isMobile ? 'pt-20' : ''}`}>
          <div className="rounded-3xl bg-white ring-1 ring-gray-200 shadow-sm min-h-[calc(100vh-3rem)] overflow-hidden">
            <Outlet />
          </div>
        </div>
      </main>
    </div>
  );
}
